import React, { useState } from "react";
import { useNavigate } from "react-router-dom";
import { getLoggedInUser } from "../utils/auth";
import ICON_MAP from "../utils/iconMap";

export default function MenuPage() {
  const navigate = useNavigate();
  const user = getLoggedInUser();

  const screens = user?.screens || [];
  const [openGroup, setOpenGroup] = useState(null);

  if (!screens.length) {
    return (
      <div style={{ padding: 40, textAlign: "center", color: "red" }}>
        No screens assigned to your role. Contact Administrator.
      </div>
    );
  }

  // 🔹 Group screens by screenGroup (camelCase)
  const groupedScreens = screens.reduce((acc, screen) => {
    const group = screen.screenGroup || "Others";
    if (!acc[group]) acc[group] = [];
    acc[group].push(screen);
    return acc;
  }, {});

  return (
    <div style={styles.container}>
      <h1 style={styles.title}>Main Menu</h1>

      <div style={styles.menu}>
        {Object.entries(groupedScreens).map(([groupName, groupScreens]) => {

          // REPORTS → DROPDOWN
          if (groupName === "Reports") {
            return (
              <div key={groupName}>
                <div
                  style={styles.card}
                  onClick={() =>
                    setOpenGroup(openGroup === "Reports" ? null : "Reports")
                  }
                >
                  <span>{ICON_MAP.inventory}</span>
                  <span>Reports {openGroup === "Reports" ? "▲" : "▼"}</span>
                </div>

                {openGroup === "Reports" && (
                  <div style={styles.subMenu}>
                    {groupScreens.map((screen) => (
                      <div
                        key={screen.screenKey}
                        style={styles.subItem}
                        onClick={() => navigate(screen.routePath)}
                      >
                        <span>
                          {ICON_MAP[screen.icon] || ICON_MAP.default}
                        </span>
                        <span>{screen.screenName}</span>
                      </div>
                    ))}
                  </div>
                )}
              </div>
            );
          }

          // ALL OTHER GROUPS → FLAT
          return groupScreens.map((screen) => (
            <div
              key={screen.screenKey}
              style={styles.card}
              onClick={() => navigate(screen.routePath)}
            >
              <span>{ICON_MAP[screen.icon] || ICON_MAP.default}</span>
              <span>{screen.screenName}</span>
            </div>
          ));
        })}
      </div>
    </div>
  );
}

/* ===========================
   STYLES
=========================== */
const styles = {
  container: {
    padding: "2rem",
    background: "#f0f2f5",
    minHeight: "100vh",
  },
  title: {
    textAlign: "center",
    marginBottom: "2rem",
    color: "#ef5252ff",
    fontSize: "24px",
    fontWeight: "700",
  },
  menu: {
    maxWidth: "520px",
    margin: "0 auto",
  },
  card: {
    background: "#fff",
    borderRadius: "12px",
    padding: "1rem",
    marginBottom: "0.8rem",
    display: "flex",
    alignItems: "center",
    gap: "1rem",
    fontSize: "18px",
    fontWeight: "500",
    cursor: "pointer",
    boxShadow: "0 3px 8px rgba(0,0,0,0.1)",
  },
  subMenu: {
    background: "#fff",
    borderRadius: "12px",
    marginBottom: "0.8rem",
    boxShadow: "0 3px 8px rgba(0,0,0,0.08)",
    padding: "0.5rem 0",
  },
  subItem: {
    padding: "0.6rem 1.2rem",
    display: "flex",
    alignItems: "center",
    gap: "0.8rem",
    cursor: "pointer",
    fontSize: "16px",
    borderBottom: "1px solid #eee",
  },
};
